import { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useDispatch } from 'react-redux';
import { create } from '../../services/upload-files.service';
import { addFacilities, start } from '../../store/slices/FacilitiesSlice';
import useFetch from '../../hooks/useFetch';
import { Card, Col, Row, Tab, Tabs } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import fetchApi from '../../services/fetch-data.service';

function ReportsDataDetails(props) {
    const { state } = useLocation();
    const [reportData, setReportData] = useState()
    const [reportingperiod, setReportingPeriod] = useState()
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()

    const fetchReportData = async (id) => {
        try {
            setLoading(true)
            const response = await fetchApi(`reports/internal/GetSavedReport/${id}`);
            setReportData(JSON.parse(response.data.report_data));
            setLoading(false)
        } catch (error) {
            console.error('Error fetching report data:', error);
        }
    };
    // console.log(reportData);
    useEffect(() => {
        if (state && state.id) {
            fetchReportData(state.id);

            const formatFromDate = new Date(state.formattedfromdate);
            const formatToDate = new Date(state.formattedtodate);

            // Get the month and year
            const frommonth = new Intl.DateTimeFormat('en-US', { month: 'long' }).format(formatFromDate);
            const fromyear = formatFromDate.getFullYear();
            const tomonth = new Intl.DateTimeFormat('en-US', { month: 'long' }).format(formatToDate);
            const toyear = formatToDate.getFullYear();

            // Output the result
            const formattedDate = `${frommonth} ${fromyear} - ${tomonth} ${toyear}`;
            setReportingPeriod(formattedDate);

        } else if (state && state.data && state.formData) {
            setReportData(state.data);
            const fromDate = state.formData.from_date;
            const toDate = state.formData.to_date;
            const formatFromDate = new Date(fromDate);
            const formatToDate = new Date(toDate);

            // Get the month and year
            const frommonth = new Intl.DateTimeFormat('en-US', { month: 'long' }).format(formatFromDate);
            const fromyear = formatFromDate.getFullYear();
            const tomonth = new Intl.DateTimeFormat('en-US', { month: 'long' }).format(formatToDate);
            const toyear = formatToDate.getFullYear();

            // Output the result
            const formattedDate = `${frommonth} ${fromyear} - ${tomonth} ${toyear}`;
            setReportingPeriod(formattedDate);

        }
    }, [state]);

    const goBack = () => {
        navigate(-1);
    };

    const handleClick = (formData) => {
        const { selectAll, ...rest } = formData;
        setLoading(true)
        create(rest, 'reports/internal/SaveInternalReport').then((res) => {
            if (res) {
                setLoading(false)
                const route = '/reports';
                navigate(route, { state: { data: res, formData: formData } });
            }
        });
    }

    if (loading) {
        return (
            <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                    <h1 className="h2 py-2">
                        <i className="fa-solid fa-spinner fa-spin"></i>
                    </h1>
                </div>
            </main>
        );
    }

    return (
        <>
            <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                    <h1 className="h2">
                        <Link onClick={goBack}>
                            <i className="fa-solid fa-arrow-left"></i>
                        </Link>
                        GHG Report {reportingperiod}
                    </h1>
                    <button className="btn-orange" onClick={() => handleClick(state.formData)} style={state && state.id ? { display: 'none' } : null}>
                        SAVE
                    </button>
                </div>
                <ul className="reportdetails">
                    <li key={3}>
                        <span>Reporting Period: </span>      <span>{reportingperiod}</span>
                    </li>
                </ul>
                <div>
                    <h4 className='tabletitle'>TOTAL EMISSIONS ACROSS ALL FACILITIES</h4>
                    <table className="table goal-details">
                        <thead>
                            <tr>
                                <th>Scope</th>
                                <th>Activity Type</th>
                                <th>Emission(kgCo2e)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {reportData && reportData.reports_by_sub_category && Object.keys(reportData.reports_by_sub_category).map((scope, idx) => {
                                return reportData.reports_by_sub_category[scope].map((data, innerIdx) => {
                                    const { title, total, sub_title } = data;

                                    return (
                                        <tr className="table-light" key={`${idx}-${innerIdx}`}>
                                            <td>
                                                {innerIdx === 0 ? scope : ""}
                                            </td>
                                            <td colSpan="1">{sub_title}</td>
                                            <td><b>{total}</b></td>
                                        </tr>
                                    );
                                });
                            })}
                        </tbody>
                    </table>
                </div>
                <div className="facility-inner">
                    <span>*Renewable energy (Solar Energy) from facility(ies) Hyderabad Facility has been offset from the total emission scope 2 </span>
                </div>

                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                </div>
                <div>
                    <h4 className='tabletitle'>DISAGGREGATION OF SCOPE 1,2 & 3 EMISSIONS BY FACILITY</h4>
                    <table className="table supplier-details">
                        <thead>
                            <tr>
                                <th>Facility</th>
                                <th>Scope</th>
                                <th>Activity Type</th>
                                <th>Emission(kgCO2e)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {reportData && Object.keys(reportData.reports_by_sub_category_facility).map((facility, idx) => {
                                return reportData.reports_by_sub_category_facility[facility].map((data, innerIdx) => {
                                    const { name, title, total, sub_title } = data;
                                    return (
                                        <tr className="table-light" key={`${idx}-${innerIdx}`}>
                                            <td>{innerIdx == 0 ? facility : ""}</td>
                                            <td>{title}</td>
                                            <td colSpan="1">{sub_title}</td>
                                            <td>{total}</td>
                                        </tr>
                                    );
                                });
                            })}
                        </tbody>
                    </table>
                </div>
            </main>
        </>
    );

}

export default ReportsDataDetails;